<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  teamName: string
}>()

const emit = defineEmits<{
  update: [name: string]
}>()

const teamNameValue = computed(() => props.teamName)

const handleInput = (e: Event) => {
  const name = (e.target as HTMLInputElement).value
  emit('update', name)
}
</script>

<template>
  <input
    type="text"
    :value="teamNameValue"
    @input="handleInput"
    :class="{
      [$style.input]: true,
    }"
    placeholder="チーム名を入力する..."
  />
</template>

<style lang="scss" module>
.input {
  &:focus {
    outline: none;
  }
}
</style>
